import ActionsForm from '@/shared/mixins/actionsForm'
import AprReportPDF from './components/aprReportPdf/aprReportPdf.vue'
import aprReport from '@/shared/http/repositories/business/aprReport'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'aprReportTable',
  components: {AprReportPDF},
  mixins: [ActionsForm],
  data () {
    return {
      columAPR: ['CÓDIGO DA APR', 'ATIVIDADE', 'ÁREA', 'Status', 'RESPONSÁVEL', 'DATA APR', 'DATA VENCIMENTO'],
      dataRelatoriaAPR: [],
      formSearch: {},
      dadosFiltro: {},
      quantitativosPDF: {}
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      loading.push()
      aprReport.GetAllRelatorioAPR(this.$refs.tableGridsRelatorioApr.pagingLimit, this.$refs.tableGridsRelatorioApr.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridsRelatorioApr.LoadAllByData(Response)
          this.dataRelatoriaAPR = Response.data.data
          if (Response.data.data.length > 0) {
            this.dadosFiltro = Response.data.data[0].filtrosAplicados
          }
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    gerarPDF () {
      this.$refs.refAprPdf.quantitativos = this.quantitativosPDF
      this.$refs.refAprPdf.filtros = this.dadosFiltro
      this.$refs.refAprPdf.formSearch = this.formSearch
      this.$refs.refAprPdf.GetAllRelatorioAPRPDF()
      // this.$refs.refAprPdf.generatePDF()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/aprReport/components/aprReportTable/aprReportTable.js